import * as React from "react"

const SvgComponent = (props) => (
  <svg
    style={{
      enableBackground: "new 0 0 64 64",
    }}
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M62 7a2 2 0 0 0-2-2H39.136C37.321 3.15 34.796 2 32 2s-5.321 1.15-7.136 3H4a2 2 0 0 0-2 2v12h22.864c1.815 1.85 4.34 3 7.136 3s5.321-1.15 7.136-3H62V7z"
      style={{
        fill: "#a0d468",
      }}
    />
    <path
      style={{
        fill: "#ffeaa7",
      }}
      d="M8 9h48v6H8z"
    />
    <path
      style={{
        fill: "#dfb28b",
      }}
      d="M4 46h56v16H4zM6 19h4v23H6zM54 19h4v23h-4z"
    />
    <path
      style={{
        fill: "#e6e9ed",
      }}
      d="M14 30h12v12H14z"
    />
    <path
      style={{
        fill: "#ff826e",
      }}
      d="M14 34h12v4H14z"
    />
    <path
      style={{
        fill: "#ccd1d9",
      }}
      d="M36 34h4v8h-4zM44 34h4v8h-4z"
    />
    <path
      style={{
        fill: "#e6e9ed",
      }}
      d="M10 50h44v8H10z"
    />
    <path
      style={{
        fill: "#cf9e76",
      }}
      d="M6 19h4v2H6zM54 19h4v2h-4zM54 40h4v2h-4zM6 40h4v2H6zM4 46h56v2H4z"
    />
    <path
      style={{
        fill: "#ccd1d9",
      }}
      d="M14 40h12v2H14z"
    />
    <path
      style={{
        fill: "#aab2bd",
      }}
      d="M36 40h4v2h-4zM44 40h4v2h-4z"
    />
    <path
      d="M61 46H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h58a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"
      style={{
        fill: "#b27946",
      }}
    />
    <path d="M57 8H7v8h50V8zm-2 6H9v-4h46v4zM55 59V49H9v10h46zm-44-8h42v6H11v-6z" />
    <path d="M63 20V7c0-1.654-1.346-3-3-3H39.544C37.494 2.062 34.832 1 32 1s-5.494 1.062-7.544 3H4C2.346 4 1 5.346 1 7v13h4v21H3c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v16h58V47c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2h-2V20h4zM3 7c0-.551.448-1 1-1h21.284l.294-.3C27.286 3.959 29.567 3 32 3s4.714.959 6.422 2.7l.294.3H60c.552 0 1 .449 1 1v11H38.716l-.294.3C36.714 20.041 34.433 21 32 21s-4.714-.959-6.422-2.7l-.294-.3H3V7zm46 34v-8h-6v8h-2v-8h-6v8h-8V29H13v12h-2V20h13.456c2.05 1.938 4.712 3 7.544 3s5.494-1.062 7.544-3H53v21h-4zm-2 0h-2v-6h2v6zm-8 0h-2v-6h2v6zm-14-8H15v-2h10v2zm-10 2h10v2H15v-2zm0 4h10v2H15v-2zM7 20h2v21H7V20zm52 41H5V47h54v14zm2.001-16H3v-2h58l.001 2zM57 41h-2V20h2v21z" />
  </svg>
)

export default SvgComponent
